export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#165D31" },
        { className: "secondary-bg-colour", colour: "#2D343B" },
        { className: "navbar-bg-colour", colour: "#2D343B" }
    ],
    text: [
        { className: "primary-text", colour: "#FFFFFF" },
        { className: "secondary-text", colour: "#165D31" }
    ],
    borders: [
        { className: "primary-border-colour", colour: "#165D31" },
    ],
    rtl: [
        { className: "rtl-text", css: "text-align: right !important; direction: rtl;" },
        { className: "rtl-layout", css: "flex-direction: row-reverse;" },
        { className: "rtl-body", css: "direction: rtl; text-align: right;" },
        { className: "rtl-container", css: "direction: rtl; text-align: right; unicode-bidi: bidi-override;" },
        { className: "rtl-input", css: "text-align: right; direction: rtl;" },
        { className: "rtl-button", css: "text-align: right; direction: rtl;" },
        { className: "rtl-header", css: "direction: rtl; text-align: right;" },
        { className: "rtl-footer", css: "direction: rtl; text-align: right;" },
        { className: "rtl-nav", css: "direction: rtl; text-align: right;" }
    ]
};
